import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { isSuggestion, Suggestion } from '@pepperhq/menu-sdk';
import { isArrayOf } from '../../../lib/typeguards';
import { Option } from '../../../lib/types';
import React from 'react';
import { ProductSuggestionType } from '../model/menu';

export const formatSuggestionsString = (suggestions: Suggestion[], productOptions: Option[]): string => {
    const suggestionGroups: { [key in ProductSuggestionType]?: string[] } = {};

    // Group suggestions by type
    suggestions.forEach(suggestion => {
        const suggestionType = suggestion.type as ProductSuggestionType;
        if (!suggestionGroups[suggestionType]) {
            suggestionGroups[suggestionType] = [];
        }

        if (suggestionType === 'bogof') {
            // For bogof, we don't need product titles
            suggestionGroups[suggestionType]?.push('Offer');
        } else {
            // For add and replace, get the product title
            const productLabel = productOptions?.find(item => item.value === suggestion.productId)?.label;
            if (productLabel && typeof productLabel === 'string') {
                suggestionGroups[suggestionType]?.push(productLabel);
            }
        }
    });

    // Format each group
    const formattedGroups: string[] = [];

    if (suggestionGroups.add && suggestionGroups.add.length > 0) {
        formattedGroups.push(`Add : ${suggestionGroups.add.join(', ')}`);
    }
    if (suggestionGroups.replace && suggestionGroups.replace.length > 0) {
        formattedGroups.push(`Replace : ${suggestionGroups.replace.join(', ')}`);
    }
    if (suggestionGroups.bogof && suggestionGroups.bogof.length > 0) {
        formattedGroups.push('Offer');
    }

    return formattedGroups.join(';  ');
};
interface SuggestionsValueProps extends GridRenderCellParams {
    productOptions: Option[];
}

const SuggestionsValue: React.FC<SuggestionsValueProps> = ({ value, productOptions }) => {
    const renderString = React.useMemo(() => {
        if (isArrayOf(isSuggestion, value)) {
            return formatSuggestionsString(value, productOptions);
        }
        return '';
    }, [value, productOptions]);

    return <span style={{ whiteSpace: 'pre' }}>{renderString}</span>;
};

export const SuggestionsViewCell = (props: GridRenderCellParams, productOptions: Option[]) => (
    <SuggestionsValue {...props} productOptions={productOptions} />
);
